// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.category-badge {
  display: inline-flex;       /* ← Changed from inline-block */
  align-items: center;        /* ← Centers vertically */
  justify-content: center;
  padding: 8px 16px;
  background: #f5f3ff;
  color: #7c3aed;
  font-size: 14px;
  font-weight: 600;
  border-radius: 16px;
  margin-bottom: 12px;
  text-decoration: none;
  width: -moz-fit-content;
  width: fit-content;
}

.category-badge:hover {
  background: #ede9fe;
}`, "",{"version":3,"sources":["webpack://./src/css/ProductCard.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB,QAAQ,gCAAgC;EAC5D,mBAAmB,SAAS,yBAAyB;EACrD,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".category-badge {\n  display: inline-flex;       /* ← Changed from inline-block */\n  align-items: center;        /* ← Centers vertically */\n  justify-content: center;\n  padding: 8px 16px;\n  background: #f5f3ff;\n  color: #7c3aed;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 16px;\n  margin-bottom: 12px;\n  text-decoration: none;\n  width: fit-content;\n}\n\n.category-badge:hover {\n  background: #ede9fe;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
